
import { Component, Prop, Vue } from "vue-property-decorator";    
import { RouterHelper } from '@/router/routerHelper';
import CourseVue from '../course/Course.vue';

@Component({
  components: {  
      'course':CourseVue
  },
})
export default class LiteBeeBrix3DownloadVue extends Vue { 
    prodName: string = "LiteBee Brix III";
    prodCode: string = "liteBeeBrix3";
    tabList: Array<any> = RouterHelper.getProdRouterConfig(this.prodCode)  ;
    

    linkData:Array<any> = [
        { name:'Home',link:'/'},
        { name: 'Suppot',link:'#'},
        { name: this.prodName, link: ("/product/" + this.prodCode) },
        { name:'COURSE',link:'#'}, 
    ];
 
}
